var _style, _polygon, _path, _path2, _path3, _rect, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuronAiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "481.2px",
    height: "77.6px",
    viewBox: "0 0 481.2 77.6",
    style: {
      enableBackground: "new 0 0 481.2 77.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#174DA0;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.5,32.6 19.5,75.8 0,75.8 0,0 20.9,0 48.7,43.9 48.7,0 68.2,0 68.2,75.8 47.3,75.8 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.9,47.5c0-16.7,12.7-30.2,29.2-30.2c16.6,0,29.3,12.3,29.3,29c0,2.4-0.1,4.7-0.4,5.9H94.6 c1.5,5.2,5.9,8.6,12.2,8.6c5.1,0,8.9-2.4,11.7-5.3l9.7,12.9c-4,4.8-12.1,9.1-22.1,9.1C88.1,77.6,74.9,64.1,74.9,47.5 M95,40.7h18.9 c-1.5-5.1-5.1-7.3-9.5-7.3C99.8,33.3,96.5,36.2,95,40.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.3,75.8h-19V19.2h19v8.8c2.7-6.2,7.3-10.5,13.5-10.5c4,0,7.1,1.1,9.5,3.2l-7.8,18c-1.9-1.7-4.8-2.7-7.7-2.7 c-4.5,0-7.5,3.7-7.5,9.3V75.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.5,56.4h-36.2l-7.8,19.4h-11.2L413.5,0H426l31.2,75.8h-11.9L437.5,56.4z M419.4,11.4l-14.2,35.5h28.5 L419.4,11.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 470.5,
    y: 0,
    className: "st0",
    width: 10.6,
    height: 75.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.4,19.2h-18.7h-5.6v18.3c5.3,1.7,8.3,7.3,6.9,12.7c-1.5,5.6-7.3,9-12.9,7.5c-5.6-1.5-9-7.3-7.5-12.9 c0.9-3.6,3.6-6.2,6.9-7.3V19.2h-5.6h-19v31.2c0,16.3,11.1,27.2,28,27.2c16.8,0,27.9-10.9,27.9-27.2V19.2H194.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.9,17.4c-16.6,0-30.2,13.5-30.2,30.2c0,16.6,13.6,30,30.2,30c16.6,0,30.2-13.5,30.2-30 C304.1,30.9,290.5,17.4,273.9,17.4 M284.2,50.2c-1.5,5.6-7.3,9-12.9,7.5c-5.6-1.5-9-7.3-7.5-12.9c1.5-5.6,7.3-9,12.9-7.5 C282.3,38.8,285.7,44.5,284.2,50.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.9,17.4c-6.7,0-11.8,3.2-14.7,8.8v-7h-19v56.6h2.9h16.2h5.1V57.6c-5.3-1.7-8.3-7.3-6.9-12.7 c1.5-5.6,7.3-9,12.9-7.5c5.6,1.5,9,7.3,7.5,12.9c-0.9,3.6-3.6,6.2-6.9,7.3v18.2h5h10h9V42C363.9,26.6,355.7,17.4,342.9,17.4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuronAiLogo);
export default __webpack_public_path__ + "static/media/NeuronAI-logo.f216a81012347eb2222bd10fecaeae3a.svg";
export { ForwardRef as ReactComponent };